import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { Router } from '@angular/router';
import { EnvironmentService } from 'src/app/services/environment.service';
import { FacilityConfig, Link } from 'src/environments/environment.interface';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
    settings: FacilityConfig;
    companyLinks: Link[] = [];
    legalLinks: Link[] = [];
    helpLinks: Link[] = [];
    cols: number = 1;
    cssCols: number = 12;

    constructor(
        public router: Router,
        private viewportScroller: ViewportScroller,
        private _environmentService: EnvironmentService
    ) { }

    ngOnInit(): void {
        this.settings = this._environmentService.getFacilityConfig();
        this.companyLinks = this._environmentService.getLinksByCategory('Company');
        this.legalLinks = this._environmentService.getLinksByCategory('Legal');
        this.helpLinks = this._environmentService.getLinksByCategory('Help');
        if(this.companyLinks.length > 0) {
            this.cols += 1;
        }
        if(this.legalLinks.length > 0) {
            this.cols += 1;
        }
        if(this.helpLinks.length > 0) {
            this.cols += 1;
        }
        switch(this.cols) {
            case 1:
                this.cssCols = 12;
                break;
            case 2:
                this.cssCols = 6;
                break;
            case 3:
                this.cssCols = 4;
                break;
            case 4:
                this.cssCols = 3;
                break;
            default:
                this.cssCols = 12;
        }
    }

    public onClick(elementId: string): void { 
        this.viewportScroller.scrollToAnchor(elementId);
    }

    public navigateTo(url: string): void {
    }

    public currentYear(): string {
        return new Date().getFullYear().toString();
    }

    getLinkUrlById(id: string): string {
        return this._environmentService.getLinkUrlById(id);
    }

    getLogoLinkUrl(): string {
        return this._environmentService.getLogoLinkUrl();
    }

    getLinkTarget(id: string): string {
        const link = this._environmentService.getLinkById(id);
        return link?.target || '_self';
    }

    getLinkTargetForLink(link: Link): string | null {
        return link?.target === '_blank' ? '_blank' : null;
    }

    showFooter(): boolean {
        return this.settings.style.footer.show;
    }
}